module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ch_02"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("Before the empires, before history, there was the Dreamtime.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The earth’s energies were known then, and mastered, and the Founders chose to mark out their channels of power. Scholars speculated that the whole world had been embellished in that golden age. They pictured an all-pervasive, varicoloured grid covering plains and valleys, forests and pastures, mapping the spirit of the land and its alliance with the heavens.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Since the Founders left the stage, epochs ago, the mesh had fallen into neglect, though it still animated the magic. But in some places, through respect or fear, the old ways were honoured, if not entirely understood.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One such was a remote hamlet not far from Bhealfa’s inhospitable eastern coast. An indigo dye line, the width of a man’s fist, ran arrow straight along its central street, marking the power’s flow. Most people tried not to step on it. The stranger arriving on foot as the sun rose didn’t seem to care about that.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His appearance, too, turned the heads of the few citizens up and about at that hour. Taller than average, and muscular, he walked with easy confidence. His weaponry included two swords, one conventionally sheathed, the other strapped across his back. Clean shaven when the norm was more often hirsute, his eyes matched the hue of his lengthy, jet-black ponytail. He had handsome features, in a chiselled, weather-beaten fashion, though the set of his face was melancholic. His clothing inclined to sombre black.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He moved through the village unfazed by the stares, appearing sure of his bearings.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The sun was climbing when he emerged from the settlement’s northern end and the street became a curving track. He took a left-hand trail, rougher and weedy. The indigo line lanced off into the countryside and faded back to dereliction.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At last he came to a house, practically hidden by untended trees. It was rambling and dilapidated. He went to the door and rapped on it. A second, louder round of knocking was necessary before he got a response.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The door was half opened by a bleary youth yet to come to terms with either the new day or manhood. He blinked at the stranger, eyes red-rimmed. ‘Yes?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘I’m looking for Grentor Domex.’ His voice was mild, but commanding all the same.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The youth stared at him. ‘Who’s asking?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘No one who means you harm. I’m not an official or a spy, just somebody who wants to consult the enchanter.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘I’m not Mage Domex,’ the youth confessed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The stranger looked him up and down, noting his spotty complexion and the flaxen bumfluff on his chin. His solemn expression softened into a thin smile. ‘No offence, friend, but I think I’d already worked that out. This "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" the Mage’s house?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was a hesitation before the youth replied, ‘It is.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Can I see him?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He thought about it, then nodded and stood aside.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The door led directly into a large, gloomy room, redolent with the aromas of the sorcerer’s craft. As the stranger entered and his eyes adjusted he saw something looming ahead of him. He blinked and recognised it as a figure standing in the partial darkness. It moved forward into a bar of daylight and revealed itself.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A battle-hardened warrior, sword levelled, about to attack.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In one swift, fluid movement, the stranger’s hand darted to the back of his collar, plucked out a snub-nosed knife and hurled it. The blade pierced the warrior’s forehead. Then it travelled on, embedding itself in a wooden beam. The warrior melted into a honeyed fog that quickly vanished. A lingering smell of sulphur overlaid the other heady scents in the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The youth realised he was gaping and snapped shut his mouth. Falteringly, he said, ‘Good thing you were right.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘About what?’ the stranger asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘About it being a glamour.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘I didn’t know.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘But –’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘If he was real he would have meant a threat. As he was a glamour, it didn’t matter. An even bet either way. Look, I said you have nothing to fear. There’s no need for party tricks.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Oh, that had nothing to do with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me")]), _vm._v(". It was one of the Mage’s protective measures.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The stranger was at the beam, tugging his knife free. ‘Was?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Yes.’ The youth sighed glumly. A world of worry settled on his naive features. ‘You’d better come.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He took him to a much smaller side chamber. It contained little except a table, and on it a body, covered by a shabby blanket. The youth peeled it back with something like reverence, exposing the head and shoulders of an elderly, white-haired man.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘So much for protective measures,’ the stranger remarked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The youth looked pained at that, but held his tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There were rope burns on the old man’s neck. The stranger indicated them.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Hanged,’ the youth supplied. ‘By paladins.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The stranger’s eyes hardened. ‘Why?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘The Mage was unlicensed. Apparently that’s a capital offence now.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Always was. They just don’t talk about it.’ He inspected the corpse again. ‘I don’t see any likeness, so I’m assuming you’re not his son.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘No. Apprentice.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘How are you known?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Kutch Pirathon.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Well met, Kutch, even if I’ve come at your time of trouble. I’m Reeth Caldason.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Recognition dawned on the lad and he gawked at the stranger, saucer-eyed. ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The")]), _vm._v(" Reeth Caldason?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Don’t worry,’ Caldason replied dryly, ‘I’m not dangerous.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘That’s not what I’ve heard.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘You shouldn’t believe everything you hear.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Are you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _vm._v(" Reeth Caldason?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Why would I lie?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Or dare if you weren’t, true.’ Kutch gazed at him with new interest. ‘I’ve never met a Qalochian before. Don’t think I’ve even seen one.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Few have these days,’ Caldason returned, his manner turned frosty. He stirred and headed for the door. ‘Well, I’m sorry for your loss, but –’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Wait.’ Kutch managed to appear bashful and eager at the same time. ‘Perhaps I can help you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘How?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘That depends on what you wanted to see my master about.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Well, it wasn’t a love charm or poison for an enemy.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘No, I suppose not. You could get those anywhere.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘What I’m saying is that my needs might be beyond… an apprentice.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘How will you know unless you tell me?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Caldason shook his head. ‘Thanks, but no.’ He started to leave again.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the larger room, Kutch dogged him. ‘I have skills, you know. The Mage taught me many things. I’ve studied with him since I was a child.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Not very long then.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kutch ignored the gibe. ‘What have you got to lose?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘My time.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Would a few more minutes make that much difference?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘And maybe my patience.’ There was distinct menace in Caldason’s tone for all its apparent mellowness. Like finding a piece of glass in a milky pudding.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They were at the front door now. ‘At least let me show you,’ Kutch stammered. ‘Let me demonstrate what I can do. And we could break fast. I’m sure you could use food and drink.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Caldason regarded the youth. ‘You’re persistent, I’ll give you that.’ He exhaled wearily. ‘All right. I’ll take bread with you, if you have it to spare.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Plenty. And there’s fowl, cheese, some fish, I think, and –’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Qalochian held up a hand to staunch Kutch’s flow. ‘But I won’t be staying long. I’ve other enchanters to find.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Well, there you are; I can give you some names. Not that you’ll want them once you’ve seen what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" can –’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘All "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("right")]), _vm._v("!’ Caldason snapped, adding more gently, ‘All right.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Magic now?’ Kutch inquired meekly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Let’s eat first.’")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Caldason’s reference to bread was literal; it was all he took, along with some water. He sat cross-legged on the floor, spine ramrod-straight, swords laid beside him. Deftly, he dissected the hunk of bread with a sharp knife, carrying small pieces to his mouth on the side of the blade.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Apparently grief hadn’t lessened Kutch’s appetite, and his repast was less frugal. He lounged opposite Caldason, back against the wall, legs stretched out, a wooden bowl in his lap.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some of the shutters had been opened and dust motes floated in the shafts of light. Caldason surveyed a room stacked with books, floor-to-ceiling shelf-loads, many in ancient bindings, some near crumbling. A plain, sturdy bench, several chairs and a moth-ravaged hanging on the only unshelved portion of wall comprised the furnishings.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kutch put down his spoon and, swallowing, said, ‘I’ve heard many stories about you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘So have I.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Silence descended.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At length, Kutch said, ‘Well?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Well what?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Are they true?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Caldason took a drink from his cup. ‘How do you come to be here?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘You’re changing the subject,’ Kutch protested.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘No, I’m interested.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The youth looked cheated, but complied. ‘There’s not much to tell. My father got himself killed when I was a toddler. My mother struggled to keep me and my older brother. Eventually he went into the army. I was sold to Master Domex. I haven’t seen my mother or brother since.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Why did Domex choose you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘He always said he saw my potential from the first.’ He shrugged his lean shoulders. ‘Sorcerers have their ways. But he was a good master.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘How did he meet his end?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘An informer, I reckon. We don’t see too many paladins around here, or militia either, then suddenly the village was crawling with them. They knew exactly where to come.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘But they did "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" no harm?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kutch reddened and bowed his head. ‘I… I hid.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After a pause, Caldason said, ‘The paladins aren’t to be gone against lightly.’ His voice was unexpectedly gentle. ‘There’s no shame in it, Kutch, and you shouldn’t feel guilt either.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘I wish I could believe that. All I know is that I wasn’t here for him.’ Caldason thought he saw the boy’s eyes misting.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘And what do you think you could have done? Fought them? You would have died too. Used your magic? They have better.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘I feel a coward.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Retreat’s a sign of intelligence, not cowardice. It means you live to fight another day. Why wasn’t your master licensed?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kutch sniffed and ran a hand across his head, smoothing back his shock of blond hair. ‘He didn’t believe in it. The Mage was a nonconformist when it came to the system, and most other things. The bastards would never have accepted him anyway. He was too much of a free thinker.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘That’s seditious talk.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘To you? I don’t think so.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Another rare, dilute smile came to Caldason’s lips. ‘What are you going to do now?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘I don’t know. I’ve always been with the Mage. Different places, but never apart. I can’t stay here though. The paladins left, but what if they come back to finish the job?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘It’s probably wise for you to go. Any idea where?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Somewhere different. Somewhere "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _vm._v("… free.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Caldason gave a hollow laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘You’re mocking me.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘No. It’s we who are mocked.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘You’re saying nowhere’s free?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘I’ve seen most of Bhealfa, and something of Gath Tampoor and Rintarah, and a few of their protectorates, and I haven’t found it. Not true freedom. Just the pretence. The silk glove hides an iron fist everywhere I’ve been.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kutch was impressed. His cheer resurfaced. ‘You’ve visited all those places? The empires themselves? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Both")]), _vm._v(" of them?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘I’ve been travelling a long time.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Aren’t you worried about being recognised?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘I try not to take unnecessary risks.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘You were out there hunting paladins, right?’ It was said conspiratorially, lacking only a wink.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Caldason ignored that and lithely got to his feet. ‘Time’s passing. How about showing me your magic?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kutch rose too, feeling as though he’d been blocked again. ‘Upstairs,’ he explained, taking a lead candleholder to light their way.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The narrow staircase was creaky and winding, and low enough that Caldason had to stoop. It was lined with recessed shelves holding more books. The upper floor revealed another spacious chamber, the twin of the one below, and unmistakably an enchanter’s workroom. All the paraphernalia of the sorcerer’s trade was on display, along with yet more books and parchment scrolls. The smell of potions, unguents, solvents and incense was even stronger than downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One of the benches held four objects, each about the size of a lobster pot, covered by black felt cloths. Kutch went to them, and allowed himself a sense of the theatrical.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘For your delectation,’ he proclaimed, ‘a wonder of the arcane arts.’ With a flourish he whipped away the first cloth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("What he unveiled was a large, bell-shaped glass jar with an immense cork in its neck. Caldason leaned forward to examine its contents. He saw scaled-down trees, bushes and rocks, and small slabs of granite piled up to make a little cave. Something had been slumbering inside. Now it woke, slanted yellow-green eyes snapping open.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A miniature dragon swaggered into the light. It arched its back and extended its wings. Head up, jaws wide, the creature’s roar was smothered by the thick glass. Then it exhaled a spume of orange flame and black smoke.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Judging the time right to move the show on, Kutch pulled off the next cloth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The second jar held a prairie scene, its sward running to the lip of a cunningly constructed timberland. In the foreground a pure white unicorn pawed the grass before rearing, its twisted horn jabbing skyward.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A harpy occupied the third jar, its habitat a jagged, dimly lit cavern. Hanging upside down like a bat, leathery wings flapping, angry red eyes ablaze, it couldn’t have been longer than Caldason’s thumb. The fourth jar was filled with water. It housed a pink coral palace. A fetching mermaid swam slowly around its turrets, silvery tail swishing, hair flowing free. Streams of tiny bubbles issued from the corners of her voluptuous lips.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kutch beamed proudly. ‘Admit it, you’re impressed. Do you know how much homunculi of this quality would cost on the open market?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘You made them?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Well… no. But I helped.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘I grant they’re well constructed. But, don’t take this the wrong way, they’re hardly original.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘No,’ Kutch allowed, smile freezing, ‘I never said they were.’ There was an air of slight annoyance in his response. ‘It’s not the homunculi themselves, it’s what I’m going to do to…’ He considered, then pointed at the dragon. ‘…"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" one.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("From a cluttered shelf he selected two flat, polished stones, reddish brown in colour and of a size to fit comfortably into his palms. The stones were decorated with runic patterns. ‘You’re going to witness a transformation. Using the Craft, I’ll change this dragon into another form. It needs quite a bit of concentration, so please be quiet.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Caldason raised an eyebrow. He leaned against the wall and folded his arms.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kutch held the stones to the jar on opposite sides, facing each other. He closed his eyes for a moment. Then he began droning an incantation in what Caldason supposed was the elder tongue. The dragon watched.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pinpricks of light appeared in the centres of the stones. They expanded, joined, spread and began pulsing. The dragon homunculus bared its fangs and lashed its forked tail. Kutch rambled on, mouthing incomprehensibly, face screwed with effort. A faint sheen of perspiration dampened his forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The glowing stones emitted a stronger radiance.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was a kind of eruption then. Both stones sent out miniature incandescent, slow-moving energy bolts that melded midway, forming a horizontal fiery tightrope. It flickered and crackled. The dragon snapped and postured.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A second later the fluctuating flow sent out a pair of tendrils. They probed the bottom of the bottle, searching out the scuttling dragon and finding it immediately. Twin sparkling currents latched on to the reluctant glamour. In turn they drew down the greater flux passing between the stones above. It bowed, U-shaped, and joined the dragon too. All the energy generated by the stones ran through the creature and bathed it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Here it comes!’ Kutch cried out, lips trembling. ‘The transformation!’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was a muffled explosion. The jar shuddered violently. Its inner surface was instantly coated with a viscous green lather. There were bits of scale and bone mixed in.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Oow!’")]), _vm._v(" Kutch yelped, dropping the stones. ‘Hot!’ Hopping, he blew furiously on his hands and flapped them about.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘You need to work on your craft,’ Caldason suggested tactfully.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘I don’t understand it.’ He was still puffing on his hands and grimacing. ‘I’ll try another.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Don’t bother. I’m not very enamoured of magic anyway.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kutch found that vaguely shocking. ‘You aren’t?’ he said, discomfort forgotten. ‘What about all its benefits?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Let’s just say there were never many for me.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘You mean you can’t afford it,’ Kutch concluded knowingly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘You could put it that way.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The youth’s manner moved to serious. ‘I really don’t know what went wrong.’ He glanced at the jars and appealed, ‘Let me have another go.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Not on my account.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘If you only give me the chance, I’m sure I could –’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("No.")]), _vm._v(" It’s past my time to leave. I must get out of here.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It seemed to Kutch that suddenly there was an almost desperate edge to Caldason’s words, and he looked tenser and furtive. Kutch made to speak, but his guest was already deserting the study. He pounded the stairs after him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Look, I’m sorry it didn’t work out quite the way I expected,’ he apologised once they reached ground level. ‘But there’s no need –’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘It’s nothing to do with that. I have to…’ He swayed, as if about to fall.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kutch was alarmed, but something about Caldason stopped him stretching out a hand. ‘What’s wrong?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Nothing.’ Caldason collected himself and straightened. ‘I’m all right.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Let me mix you a healing draught.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘No.’ His breathing was becoming laboured. He cradled his head in his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘What ails you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Just a dose of… reality.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘I don’t understand.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Caldason didn’t elaborate. All but staggering, he made his way to the swords he’d left on the floor. Looking close to passing out, he scooped them up. ‘Do you have a secure place here?’ he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Secure?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Somewhere under lock. Somewhere solid.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Why –’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Do you?’")]), _vm._v(" Caldason barked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The boy flinched. He strove to think. ‘Well, nothing except…’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘What?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Only the old demon hole.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘You have one? Here?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Yes. My master had need of it sometimes.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Take me. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Now")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Growing fearful, Kutch led the way to the cellar door. Still holding the swords, Caldason negotiated the dank steps uncertainly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The demon hole was a small vault at the cellar’s far end. It was constructed from robust stone, with a sturdy door into which a barred grille had been cut. Inside, stout iron rings were embedded in the floor, with chains and manacles attached.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Caldason lifted one of the swords.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Please don’t,’ Kutch pleaded. ‘There’s no need to lock me in there. I won’t tell about you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Not you. Me.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘What?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He thrust the sheathed swords at Kutch. ‘Take them! And these.’ Several knives joined the haul. ‘Hide them.’ He stretched a hand to the youth’s shoulder to steady himself and peeled off his boots. A buckled belt followed them. His movements were becoming erratic. He sweated, and breath didn’t seem to come easily.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘What is it?’ Kutch said. ‘Is somebody coming? Do we have to hide?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘We’ve got to trust each other. Now listen to me. Do not, under any circumstances, let me out of there until… well, you’ll probably know when. But if you have any doubts just leave me be.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘None of this makes sense.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Just do it. Please.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kutch gave him a dazed nod.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Are those the keys for the fetters?’ Caldason waved a hand at a bunch hanging from a hook on the cell’s door frame.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Then chain me.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘You want to be chained too?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘We’ve no time. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hurry")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With shaking hands, Kutch secured Caldason’s ankles and wrists.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Whatever I say or do,’ Caldason restated, ‘don’t open that door. Not if you value your life. Now get out. And stay away.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In a state of confusion, Kutch backed away from the cell. He closed the bulky door and turned its lock.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then he stood by the grille and watched what happened next in amazement.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf27548","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 72
// module chunks = 0